import { render } from "./ShiftToText.vue?vue&type=template&id=f953f100&ts=true"
import script from "./ShiftToText.vue?vue&type=script&lang=ts"
export * from "./ShiftToText.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__